import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { noAuthGuard } from './core/guards/no-auth.guard';
import { MainLayoutComponent } from './layout/main-layout/main-layout.component';

export const routes: Routes = [
  {
    path: 'auth/login',
    canActivate: [noAuthGuard],
    loadComponent: () => import('./features/auth/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'auth/register',
    canActivate: [noAuthGuard],
    loadComponent: () => import('./features/auth/register/register.component').then(m => m.RegisterComponent)
  },
  {
    path: 'auth/forgot-password',
    canActivate: [noAuthGuard],
    loadComponent: () => import('./features/auth/forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent)
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        loadComponent: () => import('./features/dashboard/dashboard.component').then(m => m.DashboardComponent)
      },
      {
        path: 'persons',
        loadComponent: () => import('./features/persons/persons-list/persons-list.component').then(m => m.PersonsListComponent)
      },
      {
        path: 'categories',
        loadComponent: () => import('./features/categories/categories-list/categories-list.component').then(m => m.CategoriesListComponent)
      },
      {
        path: 'services/categories',
        redirectTo: 'categories',
        pathMatch: 'full'
      },
      {
        path: 'services',
        loadComponent: () => import('./features/services/services-list/services-list.component').then(m => m.ServicesListComponent)
      },
      {
        path: 'products',
        loadComponent: () => import('./features/products/products-list/products-list.component').then(m => m.ProductsListComponent)
      },
      {
        path: 'movements',
        loadComponent: () => import('./features/movements/movements-list/movements-list.component').then(m => m.MovementsListComponent)
      },
      {
        path: 'sales',
        redirectTo: 'movements',
        pathMatch: 'full'
      },
      {
        path: 'duplicatas',
        redirectTo: 'duplicatas/receber',
        pathMatch: 'full'
      },
      {
        path: 'duplicatas/receber',
        loadComponent: () => import('./features/duplicatas/duplicatas-list/duplicatas-list.component').then(m => m.DuplicatasListComponent)
      },
      {
        path: 'duplicatas/pagar',
        loadComponent: () => import('./features/duplicatas/duplicatas-list/duplicatas-list.component').then(m => m.DuplicatasListComponent)
      },
      {
        path: 'banks',
        loadComponent: () => import('./features/banks/banks-list/banks-list.component').then(m => m.BanksListComponent)
      },
      {
        path: 'companies',
        loadComponent: () => import('./features/companies/companies-list/companies-list.component').then(m => m.CompaniesListComponent)
      }
    ]
  },
  { path: '**', redirectTo: 'dashboard' }
];
